// import menu_permission from '../../middleware/menu_permission';

const routes = [
  {
    path: '/tutor',
    component: () => import('../trainer/mainPage.vue'),

    children: [
      {
        name: 'tutor.dashboard',
        path: '',
        component: () => import('../trainer/dashboard/trainerDashboard.vue'),
      },
      // {
      //   name: 'tutor.myClass',
      //   path: 'myclass',
      //   component: () => import('../trainer/myClass/myClassReport.vue'),

      // },
      {
        name: 'tutor.createClass',
        path: 'create/class',
        component: () => import('../trainer/class/createClass.vue'),
      },
      {
        name: 'tutor.editClass',
        path: 'edit/class/:id',
        component: () => import('../trainer/class/editClass.vue'),
      },
      {
        name: 'tutor.class.report',
        path: 'report',
        component: () => import('../trainer/class/classReport.vue'),
      },
      {
        name: 'tutor.class.preview',
        path: 'class/preview/:id',
        component: () => import('../trainer/class/classDetails.vue'),
      },
      {
        name: 'tutor.profile',
        path: 'profile',
        component: () => import('../trainer/profile/profileReport.vue'),
      },

      {
        name: 'tutor.Reviews',
        path: 'reviews',
        component: () => import('../trainer/Reviews/Reviews.vue'),
      },
      {
        name: 'tutor.revenue',
        path: 'revenue',
        component: () => import('../trainer/Revenue/revenueReport.vue'),
      },
      // {
      //   name: 'tutor.browse.class.report',
      //   path: 'browse/class/report',
      //   component: () => import('../trainer/browseClasses/browseClassesReport.vue'),

      // },
      // {
      //   name: 'tutor.browse.class.preview',
      //   path: 'browse/class/preview/:id',
      //   component: () => import('../trainer/browseClasses/BrowseClassDetails.vue'),
      // },
      {
        name: 'tutor.add.class.lectures',
        path: 'add/class/lectures/:id',
        component: () => import('../trainer/class/addLectures.vue'),
      },
      {
        name: 'tutor.class.faq',
        path: 'class/faq/:id',
        component: () => import('../trainer/class/classFaq.vue'),
      },
      {
        name: 'tutor.ticket.report',
        path: 'ticket/report',
        component: () => import('../trainer/tickets/support_report.vue'),
      },
      {
        name: 'tutor.profileedit',
        path: 'profile/edit',
        component: () => import('../trainer/profile/editprofile'),
      },
      // {
      //   name: 'tutor.class.details',
      //   path: 'class/details',
      //   component: () => import('../trainer/class/classDetails.vue'),

      // },
    ],
  },
];
export default routes;
